export function getErrorMessage(error: unknown) {
	if (error instanceof Error) {
		return `${error.message}\nCause: ${error.cause}`;
	}

	return `${error}`;
}
